import axios from "axios";
import camelcaseKeys from "camelcase-keys";
import snakeCaseKeys from "snakecase-keys";
import { getAuthorizationToken } from "./authorization";

export interface IListResponse<T> {
  list: T[];
  total: number;
}

export type IListQuery<T = {}> = T & {
  page?: number;
  limit?: number;
};

const client = axios.create({
  timeout: 15000,
  baseURL: process.env.REACT_APP_API_BASE_URL || '/api',
});

// 请求拦截器
client.interceptors.request.use((config) => {
  const token = getAuthorizationToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  console.log('请求配置:', {
    url: config.url,
    method: config.method,
    baseURL: config.baseURL,
    headers: config.headers,
    params: config.params,
    data: config.data
  });

  if (config.params) {
    config.params = snakeCaseKeys(config.params);
    console.log('转换后的 params:', config.params);
  }
  if (
    config.data &&
    Object.prototype.toString.call(config.data) === "[object Object]"
  ) {
    config.data = snakeCaseKeys(config.data);
  }
  return config;
});

// 响应拦截器
client.interceptors.response.use(
  (response) => {
    console.log('响应成功:', {
      url: response.config.url,
      status: response.status,
      data: response.data
    });

    if (response.config.responseType === "blob") {
      return response.data;
    }
    const body = camelcaseKeys(response.data, { deep: true });
    const { success, data, errorCode, errorMessage } = body;
    if (success) {
      return data;
    }
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({ errorCode, errorMessage });
  },
  (error) => {
    console.error('请求错误:', {
      message: error.message,
      config: error.config,
      response: error.response
    });

    const resp = error.response;
    if (!resp) {
      // 网络错误或请求被取消
      if (error.code === 'ECONNABORTED') {
        return Promise.reject({
          errorCode: -2,
          errorMessage: "请求超时，请检查网络连接或后端服务是否启动"
        });
      }
      return Promise.reject({
        errorCode: -1,
        errorMessage: "网络错误，请检查后端服务是否已启动 (端口 3001)"
      });
    }

    // 服务器响应错误
    const errorMessage = resp?.data?.errorMessage || `服务器错误 (${resp.status})`;
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      errorCode: resp?.data?.errorCode || resp.status,
      errorMessage: errorMessage,
      details: resp?.data
    });
  }
);

export default client;
